import { BRAND, CONTACTS, EMAIL } from "@/lib/brand";
import { scrollToId } from "@/hooks/useLenis";
import { useLang } from "@/lib/i18n";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer
      className="bg-neutral-50 border-t-2 border-[#1478FF]"
      data-testid="footer"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-16 grid md:grid-cols-2 gap-10 items-center">
        <div className="flex items-center gap-4">
          <img
            src={BRAND.logo}
            alt={BRAND.full}
            className="h-20 w-20 object-contain rounded-full ring-1 ring-black/10"
          />
          <div>
            <p className="font-display font-semibold text-2xl text-neutral-900">
              OCD Entretien
            </p>
            <p className="text-[#1478FF] font-semibold text-xs uppercase tracking-[0.2em] mt-1">
              {BRAND.slogan}
            </p>
          </div>
        </div>

        <div className="md:justify-self-end w-full md:w-auto">
          <div className="flex flex-wrap gap-x-8 gap-y-3 md:justify-end text-sm mb-6">
            <button
              onClick={() => scrollToId("services")}
              className="text-neutral-600 hover:text-neutral-900 transition-colors"
              data-testid="footer-link-services"
            >
              {t.footer.services}
            </button>
            <button
              onClick={() => scrollToId("why")}
              className="text-neutral-600 hover:text-neutral-900 transition-colors"
              data-testid="footer-link-why"
            >
              {t.footer.why}
            </button>
            <button
              onClick={() => scrollToId("quote")}
              className="text-neutral-600 hover:text-neutral-900 transition-colors"
              data-testid="footer-link-quote"
            >
              {t.footer.quote}
            </button>
          </div>
          <div className="flex flex-col gap-3 md:items-end">
            {CONTACTS.map((c) => (
              <a
                key={c.name}
                href={`tel:${c.phone}`}
                className="group text-right"
                data-testid={`footer-contact-${c.roleKey}`}
              >
                <span className="block text-neutral-900 font-semibold group-hover:text-[#1478FF] transition-colors">
                  {c.name} · {c.phone}
                </span>
                <span className="block text-xs text-neutral-500 uppercase tracking-wider">
                  {t.roles[c.roleKey]}
                </span>
              </a>
            ))}
            <a
              href={`mailto:${EMAIL}`}
              className="group text-right pt-3 mt-1 border-t border-black/10 md:min-w-[16rem]"
              data-testid="footer-email"
            >
              <span className="block text-neutral-900 font-semibold group-hover:text-[#1478FF] transition-colors">
                {EMAIL}
              </span>
              <span className="block text-xs text-neutral-500 uppercase tracking-wider">
                Email
              </span>
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-black/10">
        <div className="max-w-7xl mx-auto px-5 md:px-8 py-6 flex flex-col sm:flex-row gap-2 justify-between text-neutral-500 text-xs">
          <p>
            © {new Date().getFullYear()} OCD Entretien Cleaning. {t.footer.rights}
          </p>
          <p>{t.footer.tagline}</p>
        </div>
      </div>
    </footer>
  );
}
